module.exports = __webpack_public_path__ + "static/cherrylimeade-71ef78eea13bea6b3e7bdfdcc2827f2b.jpg";